var map = {
	"./en/5-1/5_1class.png": 45627,
	"./fi/5-1/5_1class.png": 15725,
	"./in/5-1/5_1class.png": 62783,
	"./th/5-1/5_1class.png": 6060,
	"./tw/5-1/5_1class.png": 62793,
	"./zh/5-1/5_1class.png": 15710
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3353;